module.exports = __webpack_public_path__ + "static/preloader-500-3eac5fee5030b6d018edbcc78814f77b.png";